module.exports = __webpack_public_path__ + "media/images/icons/icn_037-3b011fdc8dcba0dbac230c2e43c6d83e.svg";